import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px",
  "data-kt-menu": "true",
  "data-kt-element": "theme-mode-menu"
}
const _hoisted_2 = { class: "menu-item px-3 my-0" }
const _hoisted_3 = {
  class: "menu-icon",
  "data-kt-element": "icon"
}
const _hoisted_4 = { class: "svg-icon svg-icon-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Claro", -1)
const _hoisted_6 = { class: "menu-item px-3 my-0" }
const _hoisted_7 = {
  class: "menu-icon",
  "data-kt-element": "icon"
}
const _hoisted_8 = { class: "svg-icon svg-icon-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Escuro", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _ctx.path,
        class: _normalizeClass([{ active: _ctx.themeMode === 'light' }, "menu-link px-3 py-2"]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMode('light')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen060.svg" })
            ])
          ]),
          _hoisted_5
        ]),
        _: 1
      }, 8, ["to", "class"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, {
        to: _ctx.path,
        class: _normalizeClass([{ active: _ctx.themeMode === 'dark' }, "menu-link px-3 py-2"]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMode('dark')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen061.svg" })
            ])
          ]),
          _hoisted_9
        ]),
        _: 1
      }, 8, ["to", "class"])
    ])
  ]))
}